import { EventCategory } from "@/types/ui";
import { FrameName } from "../config";
import EventTileEntity from "../EventTileEntity";
class SolsticeWindmillBuildingTileEntity extends EventTileEntity {
	public static readonly eventType = EventCategory.SOLAR;

	public static readonly frameName = FrameName.SOLSTICE_WINDMILL;
}

export default SolsticeWindmillBuildingTileEntity;
